import { useRef } from "react";

function Debounce<T extends (...args: any[]) => any>(callback: T, delay: number): T {
	// Create a ref that stores the callback
	const callbackRef = useRef(callback);
	// Store the latest callback.
	callbackRef.current = callback;

	// Create a ref to store the timer id
	const timerRef = useRef<NodeJS.Timeout>();

	// Return a debounced function
	return ((...args: any[]) => {
		// Clear the existing timer if the function is called before the delay
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}

		// Set a new timer
		timerRef.current = setTimeout(() => {
			// Invoke the latest callback
			callbackRef.current(...args);
		}, delay);
	}) as T;
}

export default Debounce;